export default __webpack_public_path__ + "static/media/1-2-2.cc975f3b.webp";